import { ADMIN_TYPE } from "@/enum";

export default [
  {
    path: "/fly-users",
    meta: {
      requiresAuth: true,
      permission: null,
      title: "Usuarios",
      layout: "admin",
      module: "fly-users",
      icon: "mdi-account",
      notBreadCrumb: true,
      roles: [ADMIN_TYPE.RIDERY]
    },
    component: () =>
      import(
        /* webpackChunkName: "FlyUsersLayout" */ "@/views/ridery-fly-users/RideryFlyUsersLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "fly-users-list",
        meta: {
          requiresAuth: true,
          permission: null,
          layout: "admin",
          module: "fly-users",
          title: "Listados",
          adminLayoutNav: true,
          icon: "mdi-format-list-bulleted",
          notBreadCrumb: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "RideryFlyUsersList" */ "@/views/ridery-fly-users/RideryFlyUsersList.vue"
          ),
      },
    ],
  },
];
